module.exports = __webpack_public_path__ + "static/cset_logo-64db29302c7c372a9a3d4c26404e40c9.svg";